import { render, staticRenderFns } from "./panel_royalty.vue?vue&type=template&id=5c57c6ec&scoped=true&"
import script from "./panel_royalty.vue?vue&type=script&lang=js&"
export * from "./panel_royalty.vue?vue&type=script&lang=js&"
import style0 from "./panel_royalty.vue?vue&type=style&index=0&id=5c57c6ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c57c6ec",
  null
  
)

export default component.exports